import apiClient from "../../../network/apiClient";

export const fetchEnquiriesAPI = () => apiClient.get("/customerContact/getAll", { handle404Silently: true })
export const deleteEnquiryAPI = (id) => apiClient.delete(`/customerContact/${id}`)
export const updateEnquiryStatusAPI = (body) => apiClient.put("/customerContact/update", body)